export const servicesUrl = {
  LOCAL: "https://localhost:54664/api",
  DEV: "https://mesc-service-dev.musea2.azure.ext.gm.com/ve-service/api",
  QA: "https://ve-service-api-ocf-qa.apps.pcfepgstg1mi.gm.com/api",
  TEST: "https://ve-service-api-ocf-test.apps.pcfepgstg1mi.gm.com/api",
  PERF: "https://ve-service-api-ocf-perf.apps.pcfepgstg1mi.gm.com/api",
  PROD: "https://mesc-service.musea2.azure.ext.gm.com/ve-service/api",
};

/**
 *
 */
export const mescUrl = {
  LOCAL: "http://localhost.gm.com/",
  DEV: "https://mesc-dev.musea2.azure.ext.gm.com/m",
  QA: "https://mesc-ui-ocf-qa.apps.pcfepgstg1mi.gm.com",
  TEST: "https://mesc-ui-ocf-test.apps.pcfepgstg1mi.gm.com",
  PERF: "https://mesc-ui-ocf-perf.apps.pcfepgstg1mi.gm.com",
  PROD: "https://mesc.musea2.azure.ext.gm.com/",
};

export const cgpBroadCastappId = {
  LOCAL: "94BD5E23-0D6B-4F3C-8743-2FEC3A660660",
  DEV: "94BD5E23-0D6B-4F3C-8743-2FEC3A660660",
  QA: "A78ED017-64D0-4108-A371-9E90AC81D093",
  TEST: "4F0A0DEA-CC56-4886-8C77-4B07FF97A16F",
  PERF: "",
  PROD: "9DA2A7EF-35D8-434F-8AD9-EE8D9359B665",
};

export const veInfo = {
  route: "/VE",
  title: "VE",
  subtitle: "Virtal Engineering",
  description: "Virtual Engineering",
  image: "image-ve",
  version: "0.0.0.1",
  revisionDate: "2019-01-22T11:15:21+00:00",
  services: servicesUrl,
};




